import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class AmazingCoinsWinResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("AmazingCoinsWinResourcePackage");
    }
    public get assets_views_amazing_win_popup_amazing_win_popup_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/amazing_win_popup/amazing_win_popup_1x.atlas.json");
    }
    public get assets_views_amazing_win_popup_coins_background_png(): Texture {
        return this.assets_views_amazing_win_popup_amazing_win_popup_1x_atlas_json.textures["coins_background.png"];
    }
    public get assets_views_amazing_win_popup_background_light_png(): Texture {
        return this.assets_views_amazing_win_popup_amazing_win_popup_1x_atlas_json.textures["background_light.png"];
    }
    public get assets_views_amazing_win_popup_tittle_png(): Texture {
        return this.assets_views_amazing_win_popup_amazing_win_popup_1x_atlas_json.textures["tittle.png"];
    }
    public get assets_views_amazing_win_popup_you_won_png(): Texture {
        return this.assets_views_amazing_win_popup_amazing_win_popup_1x_atlas_json.textures["you_won.png"];
    }
    public get assets_views_amazing_win_popup_coin_icon_png(): Texture {
        return this.assets_views_amazing_win_popup_amazing_win_popup_1x_atlas_json.textures["coin_icon.png"];
    }
    public get assets_views_amazing_win_popup_amazing_win_popup_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/amazing_win_popup/amazing_win_popup_1x.atlas.png");
    }
}

